export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_REQUEST_TOKEN = 'AUTH_REQUEST_TOKEN';
export const AUTH_REQUEST_TOKEN_FULL = 'AUTH_REQUEST_TOKEN_FULL';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHEK = 'AUTH_CHEK';
export const AUTH_STRUCTURE_CHANGE = 'AUTH_STRUCTURE_CHANGE';
